module.exports = __webpack_public_path__ + "static/media/NvphFanpad3.2d626ef4.webp";